<template lang="pug">
  #select-edition
    v-container(fluid)
      v-dialog(v-model="activeEditDialog" max-width="700")
        v-card.edit-card
          v-card-title.close-btn.pb-0(@click="activeEditDialog = false")
            v-icon clear
          v-card-actions.centered-btns.pt-4.pb-5
            v-btn.big-button.bolder.main-color-button.mr-5(v-if="userPermissions.updateReports" @click.native="editRecord()") Editar Relatoria
            v-btn.big-button.bolder.main-color-button.ml-5(v-if="userPermissions.updateQuestionnaire" @click.native="goToQuestionnaire()") Datos Socioeconómicos

</template>
<script>
export default {
  name: "EditDialog",
  props: ["recordId"],
  data() {
    return {
      activeEditDialog: false,
      resolve: undefined,
    };
  },
  computed: {
    userPermissions() {
      return this.$store.getters.user.permission;
    },
  },
  methods: {
    pop() {
      this.activeEditDialog = true;
    },
    editRecord() {
      this.activeEditDialog = false;
      this.$router.replace(`/edit/${this.recordId}`);
    },
    goToQuestionnaire() {
      this.activeEditDialog = false;
      this.$router.replace(`/socioec/${this.recordId}`);
    }
  }
};
</script>
<style lang="scss" scoped>
.big-button {
  height: 70px !important;
  border-radius: 8px;
}
.centered-btns {
  justify-content: center;
}
.edit-card {
  min-height: 190px;
}
.close-btn {
  justify-content: flex-end;
  .icon {
    border-radius: 10px;
    cursor: pointer;
  }
  .icon:hover {
    background-color: gainsboro;
  }
}
</style>
